export default "__VITE_ASSET__98df920b__"